// extracted by mini-css-extract-plugin
export default {"mainButtonElement":"q2TT6K","buttonPrimary":"kPumFH","buttonSecondary":"F2jqPj"};